import { i18n } from "discourse-i18n";

export default <template>
  <div class="ai-bot-sidebar-empty-state">
    {{i18n "discourse_ai.ai_bot.sidebar_empty"}}
  </div>
</template>
